// const baseUrl = "http://localhost:5000/api/v1";
const baseUrl = "https://stashbox.eu-4.evennode.com/api/v1";
// const baseUrl = "https://stashbox-staging.eu-4.evennode.com/api/v1";

const users = `${baseUrl}/admin/users`;
const savings = `${baseUrl}/admin/savings`;
const investments = `${baseUrl}/admin/investments`;
const loans = `${baseUrl}/admin/loans`;
const transactions = `${baseUrl}/admin/transactions`;
const accounts = `${baseUrl}/admin/accounts`;

function getUrl(type) {
  switch (type) {
    case "users":
      return users;
    case "savings":
      return savings;
    case "investments":
      return investments;
    case "loans":
      return loans;
    case "transactions":
      return transactions;
    case "accounts":
      return accounts;
    default:
      throw new Error("url case doesn't match any");
  }
}

export default getUrl;
